import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HttpClientModule } from '@angular/common/http';
import { provideMatomo, withRouter } from 'ngx-matomo-client';

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes),
		importProvidersFrom(HttpClientModule),
		provideMatomo(
			{
				siteId: 1,
				trackerUrl: 'https://statisticheweb.regione.emilia-romagna.it/analytics/piwik.php',
				scriptUrl: 'https://statisticheweb.regione.emilia-romagna.it/analytics/piwik.js',
				enableLinkTracking: true,
			},
			withRouter(),
		),
	],
};
